import { FC, ReactNode } from 'react';

interface ButtonProps {
  className?: string;
  variant?: string;
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  type: 'button' | 'submit' | 'reset';
}

const Button: FC<ButtonProps> = ({
  className,
  type,
  variant,
  children,
  disabled,
  onClick,
  ...rest
}) => {
  const variants: any = {
    primary: 'bg-primary-2 text-white',
    'outline-primary': 'bg-transparent text-white border border-primary-2',
    'outline-danger': 'bg-transparent text-orange-700 border border-orange-700',
  };

  return (
    <button
      onClick={onClick}
      type={type}
      {...rest}
      className={`py-2 px-6 rounded-xl font-openSans ${className} ${
        variants[variant as string]
      }`}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
